import { MAX_BEESWAX_0_5_REQUEST_ROWS } from '@/constants/axios';
import axios, { HttpStatusCode } from 'axios';
import { CLIENTS_ENDPOINT, REPORTING_GOOGLE_REPORT_ENDPOINT } from '../constants/endpoints';
import { wait } from './common';

export const getBeeswax05LookupResults = async (url, signal, params) => {
  const result = [];
  let offset = 0;
  let continueRequests = true;

  do {
    const response = await axios.get(url, {
      params: {
        offset,
        rows: MAX_BEESWAX_0_5_REQUEST_ROWS,
        ...params,
      },
      signal,
    });

    if (!response.data.success) throw new Error({ ...response });

    const responseSegments = response.data.payload;

    offset += MAX_BEESWAX_0_5_REQUEST_ROWS;
    continueRequests = responseSegments?.length >= MAX_BEESWAX_0_5_REQUEST_ROWS;

    result.push(...responseSegments);
  } while (continueRequests);

  return result;
};

export const fetchClients = async (params, signal) => {
  const result = [];
  let page = 1;
  let continueRequests = true;

  do {
    const response = await axios.get(CLIENTS_ENDPOINT, {
      params: {
        limit: 1000,
        page,
        ...params,
      },
      signal,
    });

    const { data: responseClients, meta } = response.data;

    continueRequests = !!meta.next_page_url;
    page++;

    result.push(...responseClients);
  } while (continueRequests);

  return result;
};

// google
export const getAsyncGoogleResults = async (options, url = REPORTING_GOOGLE_REPORT_ENDPOINT, retryCount = 0) => {
  const { queryId, reportId, reportType, signal, timeout = 3000 } = options;
  const res = await axios.get(url, { params: { queryId, reportId, reportType }, signal });

  if (res.status === HttpStatusCode.NoContent && retryCount < 6) {
    await wait(timeout);
    return getAsyncGoogleResults(options, url, retryCount + 1);
  }
  return res;
};
